import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CurrencyField,
  DataTable,
  DateTimeField,
  Field,
  PercentageField,
} from '../../../commons/DataTable';
import CustomerVatCodeField from '../../../commons/DataTable/CustomerVatCodeField';
import CustomerTypeField from '../../../commons/DataTable/CustomerTypeField';
import { INSURANCES_ALLOWED_TYPES } from '../../../App';
import InsuranceCheckbox from './InvoiceCheckbox';
import ActionsField from './ActionsField';
import CustomerNameField from '../../../commons/DataTable/CustomerNameField';
import ModalEditInsurance from './ModalEditInsurance';
import RenovatedBadgeField from '../../../commons/DataTable/RenovatedBadgeField';
import AdminField from '../../../commons/DataTable/AdminField';

function InsurancesTable({
  data,
  total,
  offset,
  limit,
  onFilter,
  profile,
  bottomRow,
  selectedInsurances,
  selectedAll,
  onSelectAll,
  onSelectChange,
  setModalState,
  searchAdministrators,
  searchEstateAgents,
  searchCommercials,
  fetchAdminCondos,
  fetchAdminCustomers,
  condos,
  customersExtra,
  onInsuranceUpdate,
}) {
  const [t] = useTranslation();

  const onRowClick = (row) => {
    const { _id } = row;
    if (!row.pinvInvoice?.length > 0) {
      onSelectChange(row);
    }
  };

  return (
    <DataTable
      data={data}
      total={total}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      emptyText={t('COMMON:NO_DATA')}
      bottomRow={bottomRow}
    >
      <InsuranceCheckbox
        selected={selectedInsurances}
        onSelectChange={onRowClick}
        onClick={(e) => e.stopPropagation()}
        title={
          <input
            type="checkbox"
            checked={selectedAll}
            onChange={({ target: { checked } }) => onSelectAll(checked)}
          />
        }
        visible={INSURANCES_ALLOWED_TYPES.includes(profile.type)}
      />
      <Field title="Rami" source="branch" />
      <Field title="Codice polizza" source="policy_code" />
      <Field title="Etichetta polizza" source="insurance_code" />
      <AdminField title="Referente" source="admin.businessName" />
      <Field title="Codice fiscale referente" source="admin.taxCode" />
      <Field
        title="Fornitore"
        source="supplier.businessName"
        visible={!['SUPPLIER_INS'].includes(profile.type)}
      />
      <Field
        title="Codice fiscale fornitore"
        source="supplier.taxCode"
        visible={!['SUPPLIER_INS'].includes(profile.type)}
      />
      <Field
        title="Tipo agenzia"
        source="agencyType"
        visible={!['SUPPLIER_INS'].includes(profile.type)}
      />
      <CustomerNameField title="Cliente" source="customer.name" />
      <CustomerVatCodeField title="P.Iva / Codice fiscale cliente" />
      <CustomerTypeField title="Tipologia cliente" source="customerType" />

      <DateTimeField
        title="Data creazione"
        source="createdAt"
        format="DD/MM/YYYY"
      />
      <DateTimeField
        title="Data inizio"
        source="start_date"
        format="DD/MM/YYYY"
      />
      <DateTimeField title="Data fine" source="end_date" format="DD/MM/YYYY" />
      <Field title="Fraz" source="fraz" />
      <RenovatedBadgeField title="Rinnovata" source="renovated" />
      <CurrencyField
        title="Premio lordo"
        source="gross"
        className="txt-table-right"
      />
      <CurrencyField
        title="Premio netto"
        source="net"
        className="txt-table-right"
      />
      <CurrencyField
        title="ROY La Panoramica"
        source="shareToInvoice"
        className="txt-table-right"
      />
      <PercentageField
        title="ROY La Panoramica %"
        source="shareToInvoicePerc"
        className="txt-table-right"
      />
      <CurrencyField
        title="Profitto La Panoramica"
        source="panoramicaShare"
        className="txt-table-right"
      />
      <CurrencyField
        title="Profitto Sub Agenzia"
        source="adminShare"
        className="txt-table-right"
      />
      <PercentageField
        title="Profitto Sub Agenzia %"
        source="subAgencyPerc"
        className="txt-table-right"
      />
      <ModalEditInsurance
        title="Modifica"
        onConfirm={onInsuranceUpdate}
        searchAdministrators={searchAdministrators}
        searchEstateAgents={searchEstateAgents}
        searchCommercials={searchCommercials}
        fetchAdminCondos={fetchAdminCondos}
        fetchAdminCustomers={fetchAdminCustomers}
        condos={condos}
        customersExtra={customersExtra}
        visible={['SUPPLIER_INS'].includes(profile?.type)}
      />
      <ActionsField
        title="Fattura Extra"
        onViewInvoice={(extraInvoiceId) =>
          setModalState({ isOpen: true, selectedId: extraInvoiceId })
        }
        visible={INSURANCES_ALLOWED_TYPES.includes(profile.type)}
      ></ActionsField>
    </DataTable>
  );
}

export default InsurancesTable;
